module.exports = __webpack_public_path__ + "static/media/Web-on Asia.3e18d95b.png";